<!-- Modal (Consultar (Pagamento)) -->

<ng-template #consultarPagamento let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-consultar-pagamento"><b>Consultar (Pagamento)</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="table-responsive">
      <table class="table table-sm">
        <thead>
          <tr>
            <th>Email</th>
            <th class="text-center tabela_borda">Plataforma</th>
            <th class="text-center tabela_borda">Dt. Criação</th>
            <th class="text-center tabela_borda">Dt. Atualização</th>
            <th class="text-center tabela_borda">Dt. Aprovação</th>
            <th class="text-center tabela_borda">Parcelas</th>
            <th class="text-right tabela_borda">Valor: R$</th>
            <th class="tabela_borda">Status</th>
            <th class="tabela_borda">Detalhes</th>
          </tr>
        </thead>

        <tbody>
          @if (pedidoPagamento != null) {
            <tr>
              <td>{{ pedidoPagamento.email }}</td>
              <td class="text-center tabela_borda">{{ pedidoPagamento.plataform }}</td>
              <td class="text-center tabela_borda">{{ pedidoPagamento.date_created | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
              <td class="text-center tabela_borda">{{ pedidoPagamento.date_last_updated | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
              <td class="text-center tabela_borda">{{ pedidoPagamento.date_approved | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
              <td class="text-center tabela_borda">{{ pedidoPagamento.installments }}</td>
              <td class="text-right tabela_borda">{{ pedidoPagamento.transaction_amount | currency: 'BRL' }}</td>
              @if (pedidoPagamento.status == 'approved') {
                <td class="tabela_borda">Aprovado</td>
              }
              @if (pedidoPagamento.status == 'authorized') {
                <td class="tabela_borda">Autorizado</td>
              }
              @if (pedidoPagamento.status == 'in_process') {
                <td class="tabela_borda">Em processamento</td>
              }
              @if (pedidoPagamento.status == 'pending') {
                <td class="tabela_borda">Pendente</td>
              }
              @if (pedidoPagamento.status_detail == 'accredited') {
                <td class="tabela_borda">Creditado</td>
              }
              @if (pedidoPagamento.status_detail == 'pending_contingency') {
                <td class="tabela_borda">Em contigência</td>
              }
              @if (pedidoPagamento.status_detail == 'cc_rejected_other_reason') {
                <td class="tabela_borda">Em análise</td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Ok')">Ok</button>
  </div>
</ng-template>

<!-- Modal (Reprovar) -->

<ng-template #pedidoReprovar let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-pedido-reprovar"><b>Reprovar (Pedido)</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="pb-4">
      <div class="form-row">
        <div class="form-group col-sm-12">
          <label><b>Motivo:</b></label>

          <input class="form-control form-control-sm" type="text" name="motivo" [(ngModel)]="motivoReprovacao" />
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-secondary btn_formulario" type="button" (click)="modal.close('Cancelar')">Cancelar</button>
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Salvar')">Salvar</button>
  </div>
</ng-template>

<!-- Modal (Status) -->

<ng-template #pedidoStatus let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-pedido-status"><b>Status (Pedido)</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="table-responsive">
      <table class="table table-sm">
        <thead>
          <tr>
            <th class="text-center">Data</th>
            <th class="tabela_borda">Observação</th>
          </tr>
        </thead>

        <tbody>
          @for (pedidoStatus of pedidosStatus; track pedidoStatus) {
            <tr>
              <td class="text-center">{{ pedidoStatus.data | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
              <td class="tabela_borda">{{ pedidoStatus.obs }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Ok')">Ok</button>
  </div>
</ng-template>

<div class="pt-3 pr-4 pb-4 pl-4" [@esvanecerDesvanecer]="'in'">
  <!-- Filtro -->

  <form [formGroup]="formFiltro" (ngSubmit)="filtrar(true)">
    @if (erroPeriodo) { <p class="text-danger" role="alert">{{ erroPeriodo }}</p> }
    <div class="form-row">
      <div class="form-group col-sm-2">
        <label class="text-secondary"><b>Filtrar por:</b></label>

        <select class="form-control form-control-sm" name="filtrar_enviados_por" formControlName="filtro" (change)="alterarFiltro($event.target.value)">
          @for (opcao of filtroOpcoes; track opcao) {
            <option [value]="opcao.valor" [selected]="opcao.valor == f.filtro.value">{{ opcao.texto }}</option>
          }
        </select>
      </div>

      <!-- Período (Enviado) -->

      <div class="form-group col-sm-2">
        <label class="text-secondary"><b>Dt. Inicial:</b></label>

        <input class="form-control form-control-sm" type="text" name="enviados_filtrar_dt_inicial" ngbDatepicker #dt_inicial="ngbDatepicker" (click)="dt_inicial.toggle()" formControlName="dt_inicial" />
      </div>

      <div class="form-group col-sm-2">
        <label class="text-secondary"><b>Dt. Final:</b></label>

        <input [appPeriodoFinal]="formFiltro.controls['dt_inicial'].value" class="form-control form-control-sm" type="text" name="enviados_filtrar_dt_final" ngbDatepicker #dt_final="ngbDatepicker" (click)="dt_final.toggle()" formControlName="dt_final" />
      </div>

      <!-- Cliente -->

      @if (f.filtro.value == 1) {
        <div class="form-group col-sm-4">
          <label class="text-secondary"><b>Cliente:</b></label>
          <input class="form-control form-control-sm" type="text" name="enviados_filtrar_cliente" [ngClass]="{ 'is-invalid': enviado && f.cliente.errors?.required }" formControlName="cliente" />
          @if (enviado && f.cliente.errors?.required) {
            <div class="erro pt-1">Cliente em branco!</div>
          }
        </div>
      }

      <!-- Nro Pedido -->

      @if (f.filtro.value == 2) {
        <div class="form-group col-sm-2">
          <label class="text-secondary"><b>Nro Pedido:</b></label>
          <input class="form-control form-control-sm" type="number" min="1" step="1" name="enviados_filtrar_nro_pedido" [ngClass]="{ 'is-invalid': enviado && f.nro_pedido.errors?.required }" formControlName="nro_pedido" />
          @if (enviado && f.nro_pedido.errors?.required) {
            <div class="erro pt-1">Nro Pedido em branco!</div>
          }
        </div>
      }

      <!-- Status -->

      @if (f.filtro.value == 3) {
        <div class="form-group col-sm-2">
          <label class="text-secondary"><b>Status:</b></label>
          <select class="form-control form-control-sm" name="enviados_status" formControlName="status">
            @for (opcao of filtroStatus; track opcao) {
              <option [value]="opcao.valor" [selected]="opcao.valor == f.status.value" [hidden]="!configuracao.mostra_faturado && (opcao.valor == 'Faturado' || opcao.valor == 'Faturado Div')">{{ opcao.texto }}</option>
            }
          </select>
          @if (enviado && f.status.errors?.required) {
            <div class="erro pt-1">Status em branco!</div>
          }
        </div>
      }

      <!-- Vendedor(a) -->

      <div class="form-group col-sm-3">
        <label class="text-secondary"><b>Vendedor(a):</b></label>

        <app-vendedor-typeahead
          [vendedorSelecionado]="f.vendedor.value"
          (vendedorChange)="f.vendedor.setValue($event)">
        </app-vendedor-typeahead>
      </div>

      <div class="col-sm-3">
        <div class="btn_filtro_grupo">
          <button class="btn btn-secondary btn_filtro" type="submit">Filtrar</button>

          @if (filtrado) {
            <button class="btn btn-secondary btn_filtro" type="button" (click)="alterarFiltro(null)">Cancelar</button>
          }
          @if (pedidos.length > 0 && (is_master || is_manager || is_diretor || is_financeiro)) {
            <button
              class="btn btn-success btn_filtro"
              type="button"
              (click)="exportarExcel()"
              [disabled]="excelExportando">
              {{ excelExportando ? 'Gerando...' : 'Exportar Excel' }}
            </button>
          }
          @if (pedidos.length > 0 && is_diretor) {
            <button
              class="btn btn-warning btn_filtro"
              type="button"
              (click)="exportarExcelDiretoria()"
              [disabled]="excelDiretoriaExportando">
              {{ excelDiretoriaExportando ? 'Gerando...' : 'Excel Diretoria' }}
            </button>
          }
        </div>
      </div>
    </div>

    <div class="d-flex flex-column">
      <!-- B2B -->

      @if (configuracao != null && configuracao.pedido_filtrar_b2b) {
        <div class="form-group col-sm-1">
          <input class="form-check-input" type="checkbox" id="filtrar_b2b" formControlName="filtrar_b2b" (change)="filtrarB2B()">
          <label class="form-check-label text-secondary" for="filtrar_b2b"><b>B2B</b></label>
        </div>
      }

      <!-- Cancelado -->

      <div class="form-group col-sm-1">
        <input class="form-check-input" type="checkbox" id="filtrar_cancelado" formControlName="filtrar_cancelado" (change)="filtrarCancelado()">

        <label class="form-check-label text-secondary" for="filtrar_cancelado"><b>Cancelado</b></label>
      </div>
    </div>
  </form>

  <!-- Modelo 1 -->

  @if (modelo_tela_ligacoes == 0) {
    @if (pedidos.length > 0) {
      <div class="pb-2">
        <div class="form-row">
          <div class="form-group col-sm-2">
            <label class="text-secondary"><b>Ordenar por:</b></label>
            <select class="form-control form-control-sm" name="ordernar_pedidos_por" [(ngModel)]="ordernarPedidosSelecionado" (change)="ordernarPedidos($event.target.value)">
              @for (opcao of ordernarPedidosOpcoes; track opcao) {
                <option [value]="opcao.valor" [selected]="opcao.valor == ordernarPedidosSelecionado">{{ opcao.texto }}</option>
              }
            </select>
          </div>
          <div class="form-group col-sm-2">
            <label class="text-secondary">&nbsp;</label>
            <select class="form-control form-control-sm" name="ordernar_pedidos_por_ordem" [(ngModel)]="ordernarPedidosOrdemSelecionado" (change)="ordernarPedidosOrdem($event.target.value)">
              @for (opcao of ordernarPedidosOpcoesOrdem; track opcao) {
                <option [value]="opcao.valor" [selected]="opcao.valor == ordernarPedidosOrdemSelecionado">{{ opcao.texto }}</option>
              }
            </select>
          </div>
        </div>
      </div>
    }
    <div class="table-responsive">
      <div class="tabela_paginada">
        <table class="table table-sm">
          <thead>
            <tr>
              <th></th>
              <th class="tabela_borda"></th>
              <th class="tabela_borda"></th>
              <th class="tabela_borda"></th>
              <th class="text-center tabela_borda">Status</th>
              <th class="text-center tabela_borda">Nro Pedido</th>
              <th class="text-center tabela_borda">Nro (ERP)</th>
              <th class="tabela_borda">Vend Externo</th>
              <th class="tabela_borda">Vend Interno</th>
              <th class="tabela_borda">Cliente</th>
              <th class="text-center tabela_borda">CNPJ/CPF</th>
              <th class="text-right tabela_borda">Total: R$</th>
              <th class="text-right tabela_borda">Litragem</th>
              @if (configuracao != null && configuracao.mostra_faturado) {
                <th class="text-right tabela_borda">Faturado: R$</th>
              }
              <th class="text-center tabela_borda">Enviado</th>
              <th class="text-center tabela_borda">Pedido Programado</th>
              <th class="text-center tabela_borda">Liberado</th>
              <th class="text-center tabela_borda">Integrado</th>
              <th class="tabela_borda">Prazo Pagto</th>
              <th class="text-center tabela_borda">Tipo</th>
              @if (configuracao != null && configuracao.mostra_faturado) {
                <th class="text-center tabela_borda">Nota Fiscal</th>
              }
            </tr>
          </thead>
          <tbody>
            @for (pedido of pedidos; track pedido; let i = $index) {
              <tr [ngClass]="pedido.order_id_app.toString().substring(0, 3) == '130' ? 'bg_tabela_info' : ''">
                <td class="text-center tabela_acao">
                  <i class="fa  btn_tabela_acao" [ngClass]="i == itemExpandido ? 'fa-arrow-up' : 'fa-arrow-down'" placement="right" ngbTooltip="Expandir/Recolher" (click)="expandir(i, pedido.order_id_app, pedido.seller_id)"></i>
                </td>
                <td class="text-center tabela_acao tabela_borda">
                  <i class="fa fa-file btn_tabela_acao" placement="right" ngbTooltip="PDF" (click)="imprimir(pedido.order_id_app, pedido.seller_id)"></i>
                </td>
                <td class="text-center tabela_acao tabela_borda">
                  @if (pedido.id_order_payment != null) {
                    <i class="fa fa-credit-card btn_tabela_acao" placement="right" ngbTooltip="Consultar Pagamento" (click)="modalConsultarPagamento(consultarPagamento, pedido.id_order_payment)"></i>
                  }
                </td>
                <td class="text-center tabela_acao tabela_borda">
                  <i class="fa fa-info btn_tabela_acao" placement="right" ngbTooltip="Status" (click)="modalPedidoStatus(pedidoStatus, pedido.order_id_app)"></i>
                </td>
                <td class="text-center tabela_borda">
                  @if (pedido.status_pedido == 'À Integrar') {
                    <span class="badge badge-primary">{{ pedido.status_pedido }}</span>
                  }
                  @if (pedido.status_pedido == 'Aguard Aprov') {
                    <span class="badge badge-warning">{{ pedido.status_pedido }}</span>
                  }
                  @if (pedido.status_pedido == 'Aguard Financeiro') {
                    <span class="badge badge-financeiro">{{ pedido.status_pedido }}</span>
                  }
                  @if (pedido.status_pedido == 'Aguard Gerencial') {
                    <span class="badge badge-gerencial">{{ pedido.status_pedido }}</span>
                  }
                  @if (pedido.status_pedido == 'Aguard Diretor') {
                    <span class="badge badge-diretor">{{ pedido.status_pedido }}</span>
                  }
                  @if (pedido.status_pedido == 'Aguard Coordenador') {
                    <span class="badge badge-coordenador">{{ pedido.status_pedido }}</span>
                  }
                  @if (pedido.status_pedido == 'Aguard Cad') {
                    <span class="badge badge-secondary">{{ pedido.status_pedido }}</span>
                  }
                  @if (pedido.status_pedido == 'Cancelado') {
                    <span class="badge badge-distinct">{{ pedido.status_pedido }}</span>
                  }
                  @if (pedido.status_pedido == 'Erro Integ') {
                    <span class="badge badge-danger">{{ pedido.status_pedido }}</span>
                  }
                  @if (pedido.status_pedido == 'Faturado') {
                    <span class="badge badge-info">{{ pedido.status_pedido }}</span>
                  }
                  @if (pedido.status_pedido == 'Faturado Div') {
                    <span class="badge badge-other">{{ pedido.status_pedido }}</span>
                  }
                  @if (pedido.status_pedido == 'Integrado') {
                    <span class="badge badge-success">{{ pedido.status_pedido }}</span>
                  }
                  @if (pedido.status_pedido == 'Reprovado') {
                    <span class="badge badge-dark">{{ pedido.status_pedido }}</span>
                  }
                </td>
                <td class="text-center tabela_borda">{{ pedido.order_id_app }}</td>
                <td class="text-center tabela_borda">{{ pedido.id_no_erp_do_cliente }}</td>
                <td class="tabela_borda">{{ pedido.vend_ext }}</td>
                <td class="tabela_borda">{{ pedido.vend_int }}</td>
                <td class="tabela_borda">{{ pedido.name }}</td>
                <td class="text-center tabela_borda">{{ pedido.client_document }}</td>
                <td class="text-right tabela_borda">{{ pedido.total | currency: 'BRL' }}</td>
                <td class="text-right tabela_borda">{{ pedido.total_litragem | currency: 'BRL' : '' }}</td>
                @if (configuracao != null && configuracao.mostra_faturado) {
                  <td class="text-right tabela_borda">
                    {{ pedido.total_fat | currency: 'BRL' }}
                  </td>
                }
                <td class="text-center tabela_borda">{{ pedido.order_sent_on | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                <td class="text-center tabela_borda">{{ pedido.dt_previsao_entrega | date: 'dd/MM/yyyy' }}</td>
                <td class="text-center tabela_borda">{{ pedido.dt_liberacao_master | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                <td class="text-center tabela_borda">{{ pedido.dt_integracao | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                <td class="tabela_borda">{{ pedido.prazo_pgto }}</td>
                <td class="text-center tabela_borda pedido_tipo_coluna">
                  <span class="pedido_tipo_conteudo">
                    <span>{{ pedido.cod_tipopedvenda }}</span>
                    @if (pedido.tipo === 'E' || pedido.tipo === 'S') {
                      <span class="badge pedido_tipo_tag" [class.badge-success]="pedido.tipo === 'E'" [class.badge-danger]="pedido.tipo === 'S'">{{ pedido.tipo }}</span>
                    }
                  </span>
                </td>
                @if (configuracao != null && configuracao.mostra_faturado) {
                  <td class="text-center tabela_borda">
                    {{ pedido.numero_nf }}
                  </td>
                }
              </tr>
              @if (i == itemExpandido) {
                <tr [@esvanecerDesvanecer]="'in'">
                  <td class="p-3" [attr.colspan]="configuracao != null && configuracao.mostra_faturado ? 16 : 14">
                    <div class="tabela_sm tabela_itens_expandida">
                      <table class="table table-sm table-hover">
                        <thead>
                          <tr>
                            <th class="text-center">Código</th>
                            <th class="tabela_borda">Descrição</th>
                            <th class="text-center tabela_borda">Qtde</th>
                            <th class="text-right tabela_borda">Unitário: R$</th>
                            @if (exibirFatorFinanceiro) {
                              <th class="text-right tabela_borda">Fator: R$</th>
                            }
                            @if (configuracao != null && configuracao.flag_exibir_imposto_produto) {
                              <th class="text-right tabela_borda">Imposto: R$</th>
                            }
                            @if (exibirFatorFinanceiro || (configuracao != null && configuracao.flag_exibir_imposto_produto)) {
                              <th class="text-right tabela_borda">Unitário (Final): R$</th>
                            }
                            <th class="text-right tabela_borda">Sub-Total: R$</th>
                            @if (configuracao != null && configuracao.mostra_faturado) {
                              <th class="text-right tabela_borda">Faturado: R$</th>
                            }
                            @if (is_master || is_manager || is_diretor) {
                              <th class="text-right tabela_borda">Margem: %</th>
                            }
                            <th class="text-right tabela_borda">Tabela: R$</th>
                            <th class="tabela_borda">Promoção</th>
                            <th class="text-right tabela_borda">Preço Promoção: R$</th>
                            <th class="text-right tabela_borda">Desconto: R$</th>
                            <th class="text-right tabela_borda">Desconto: %</th>
                          </tr>
                        </thead>
                        <tbody>
                          @for (pedidoItem of pedidosItens; track pedidoItem) {
                            <tr>
                              <td class="text-center">{{ pedidoItem.referencia_cliente }}</td>
                              <td class="tabela_borda">{{ pedidoItem.produto }}</td>
                              <td class="text-center tabela_borda">{{ pedidoItem.quantity }}</td>
                              <td class="text-right tabela_borda">{{ formatarValoresQuatroCasasDecimais(pedidoItem.vr_unitario_original) }}</td>
                              @if (exibirFatorFinanceiro) {
                                <td class="text-right tabela_borda">{{ pedidoItem.fator_financeiro | currency: 'BRL' }}</td>
                              }
                              @if (configuracao != null && configuracao.flag_exibir_imposto_produto) {
                                <td class="text-right tabela_borda">{{ pedidoItem.valor_imposto | currency: 'BRL' }}</td>
                              }
                              @if (exibirFatorFinanceiro || (configuracao != null && configuracao.flag_exibir_imposto_produto)) {
                                <td class="text-right tabela_borda">{{ pedidoItem.vr_unitario_acumulado | currency: 'BRL' }}</td>
                              }
                              <td class="text-right tabela_borda">{{ pedidoItem.vr_sub_total_acumulado | currency: 'BRL' }}</td>
                              @if (configuracao != null && configuracao.mostra_faturado) {
                                <td class="text-right tabela_borda">{{ pedidoItem.totalfat | currency: 'BRL' }}</td>
                              }
                              @if (is_master || is_manager || is_diretor) {
                                <td class="text-right tabela_borda">{{ pedidoItem.mkt | currency: 'BRL' : '' }}%</td>
                              }
                              @if (configuracao != null && !configuracao.exibe_price_como_tabela_pedidos) {
                                <td class="text-right tabela_borda">{{ pedidoItem.preco_tabela | currency: 'BRL' }}</td>
                              }
                              @if (configuracao != null && configuracao.exibe_price_como_tabela_pedidos) {
                                <td class="text-right tabela_borda">{{ pedidoItem.precotabela2 | currency: 'BRL' }}</td>
                              }
                              <td class="tabela_borda">{{ pedidoItem.nome_promocao }}</td>
                              <td class="text-right tabela_borda">{{ pedidoItem.preco_tabela | currency: 'BRL' }}</td>
                              <td class="text-right tabela_borda">{{ pedidoItem.valor_desconto | currency: 'BRL' }}</td>
                              @if (configuracao != null && !configuracao.exibe_price_como_tabela_pedidos) {
                                <td class="text-right tabela_borda">{{ pedidoItem.desc_aplicado | currency: 'BRL' : '' }}%</td>
                              }
                              @if (configuracao != null && configuracao.exibe_price_como_tabela_pedidos) {
                                <td class="text-right tabela_borda">{{ pedidoItem.desc_aplicado2 | currency: 'BRL' : '' }}%</td>
                              }
                            </tr>
                            @if (configuracao != null && configuracao.flag_exibe_observacao_item_pedido && pedidoItem.observacao_item != null && pedidoItem.observacao_item != '') {
                              <tr>
                                <td></td>
                                <td class="tabela_borda" colspan="15">
                                  {{ pedidoItem.observacao_item }}
                                </td>
                              </tr>
                            }
                          }
                        </tbody>
                        <tfoot>
                          <tr>
                            <td class="tabela_borda_inferior"></td>
                            <td class="tabela_borda_inferior"></td>
                            <td class="tabela_borda_inferior"></td>
                            <td class="tabela_borda_inferior"></td>
                            @if (exibirFatorFinanceiro) {
                              <td class="tabela_borda_inferior"></td>
                            }
                            @if (configuracao != null && configuracao.flag_exibir_imposto_produto) {
                              <td class="tabela_borda_inferior"></td>
                            }
                            @if (exibirFatorFinanceiro || (configuracao != null && configuracao.flag_exibir_imposto_produto)) {
                              <td class="tabela_borda_inferior"></td>
                            }
                            <td class="tabela_borda_inferior"></td>
                            @if (configuracao != null && configuracao.mostra_faturado) {
                              <td class="tabela_borda_inferior"></td>
                            }
                            @if (is_master || is_manager || is_diretor) {
                              <td class="tabela_borda_inferior"></td>
                            }
                            <td class="tabela_borda_inferior"></td>
                            <td class="tabela_itens_valor_saldo tabela_borda_inferior text-right"><b>Saldo: R$</b></td>
                            <td class="tabela_borda_inferior tabela_borda text-right">
                              @if (pedidosItensSaldo < 0) {
                                <span class="badge badge-danger">{{ pedidosItensSaldo | currency: 'BRL' }}</span>
                              }
                              @if (pedidosItensSaldo == 0) {
                                <span class="badge badge-primary">{{ pedidosItensSaldo | currency: 'BRL' }}</span>
                              }
                              @if (pedidosItensSaldo > 0) {
                                <span class="badge badge-success">{{ pedidosItensSaldo | currency: 'BRL' }}</span>
                              }
                            </td>
                            <td class="tabela_borda_inferior tabela_borda"></td>
                          </tr>
                          @if (pedidosItens.length > 0 && (is_master || is_manager || is_diretor || is_financeiro)) {
                            <tr>
                              <td class="tabela_borda_inferior"></td>
                              <td class="tabela_borda_inferior"></td>
                              <td class="tabela_borda_inferior"></td>
                              <td class="tabela_borda_inferior"></td>
                              @if (exibirFatorFinanceiro) {
                                <td class="tabela_borda_inferior"></td>
                              }
                              @if (configuracao != null && configuracao.flag_exibir_imposto_produto) {
                                <td class="tabela_borda_inferior"></td>
                              }
                              @if (exibirFatorFinanceiro || (configuracao != null && configuracao.flag_exibir_imposto_produto)) {
                                <td class="tabela_borda_inferior"></td>
                              }
                              <td class="tabela_borda_inferior"></td>
                              @if (configuracao != null && configuracao.mostra_faturado) {
                                <td class="tabela_borda_inferior"></td>
                              }
                              @if (is_master || is_manager || is_diretor) {
                                <td class="tabela_borda_inferior"></td>
                              }
                              <td class="tabela_borda_inferior"></td>
                              <td class="tabela_itens_valor_saldo tabela_borda_inferior text-right"><b>Margem:</b></td>
                              <td class="tabela_borda_inferior tabela_borda text-right">
                                <div class="tabela_itens_valor_margem"><b>{{ pedidosItens[0].mkt_pedido | currency: 'BRL' : '' }}%</b></div>
                              </td>
                              <td class="tabela_borda_inferior tabela_borda"></td>
                            </tr>
                          }
                          @if (pedido.observacao_interna != null && pedido.observacao_interna.trim() != '') {
                            <tr>
                              <td class="tabela_itens_observacao" colspan="14"><b>Observação Interna:</b> {{ pedido.observacao_interna }}</td>
                            </tr>
                          }
                          @if (pedido.observacao_nf != null && pedido.observacao_nf.trim() != '') {
                            <tr>
                              <td class="tabela_itens_observacao" colspan="14"><b>Observação Nota Fiscal:</b> {{ pedido.observacao_nf }}</td>
                            </tr>
                          }
                          @if (pedidosItens.length > 0 && pedidosItens[0].localentrega != null && pedidosItens[0].localentrega.trim() != '') {
                            <tr>
                              <td class="tabela_itens_local_entrega" colspan="14">
                                <span><b>Local de Entrega:</b> {{ pedidosItens[0].localentrega }}</span>
                              </td>
                            </tr>
                          }
                        </tfoot>
                      </table>
                    </div>
                  </td>
                  @if (pedidosItens.length > 0) {
                    <td class="pt-3 pb-3" colspan="5">
                      <div class="text-center p-0">
                        <div class="tabela_itens_valor_total"><b>Valor Total: {{ pedidosItens[0].vr_total_acumulado | currency: 'BRL' }}</b></div>
                      </div>
                      <div class="text-center p-0">
                        @if (is_master || is_manager || is_diretor) {
                          <div class="tabela_itens_valor_margem"><b>Margem: {{ pedidosItens[0].mkt_pedido | currency: 'BRL' : '' }}%</b></div>
                        }
                      </div>
                      @if (configuracao != null && !configuracao.usa_integracao && (pedido.status_pedido == 'À Integrar' || pedido.status_pedido == 'Aguard Cad')) {
                        <div class="text-center pt-2">
                          <button class="btn btn-success btn_tabela" (click)="integrar(pedido.order_id_app, pedido.seller_id)">Integrar</button>
                        </div>
                      }
                      @if (configuracao != null && configuracao.usa_integracao && configuracao.flag_integra_pedidos_tempo_real && pedido.status_pedido == 'À Integrar') {
                        <div class="text-center pt-2">
                          <button class="btn btn-success btn_tabela" (click)="reintegrar(pedido.order_id_app, pedido.seller_id)">Reintegrar</button>
                        </div>
                      }
                      @if (podeAprovarPedido(pedido)) {
                        <div class="text-center pt-2">
                          <button class="btn btn-success btn_tabela" (click)="aprovar(pedido.order_id_app, pedido.seller_id)">Aprovar</button>
                          <button class="btn btn-danger btn_tabela" (click)="modalPedidoReprovar(pedidoReprovar, pedido.order_id_app, pedido.seller_id)">Reprovar</button>
                          <button class="btn btn-warning btn_tabela" (click)="analisar(pedido.order_id_app, pedido.seller_id)">Analisar</button>
                        </div>
                      }
                      @if (pedido.status_pedido == 'Erro Integ') {
                        <div class="text-center pt-2">
                          <button class="btn btn-success btn_tabela" (click)="reintegrar(pedido.order_id_app, pedido.seller_id)">Reintegrar</button>
                          <button class="btn btn-success btn_tabela" (click)="retornar(pedido.order_id_app, pedido.seller_id)">Retornar</button>
                        </div>
                      }
                      @if (pedido.status_pedido == 'Reprovado') {
                        <div class="text-center pt-2">
                          <button class="btn btn-success btn_tabela" (click)="retornar(pedido.order_id_app, pedido.seller_id)">Retornar</button>
                        </div>
                      }
                      <div class="text-center pt-2">
                        <button class="btn btn-secondary btn_tabela" (click)="duplicar(pedido.order_id_app, pedido.seller_id)">Duplicar</button>
                      </div>
                    </td>
                  }
                </tr>
              }
            }
          </tbody>
        </table>
      </div>
    </div>
    <!-- Paginação -->
    <app-pagination
      [page]="page"
      [totalPages]="totalPages"
      [totalItems]="total"
      [pageSize]="pageSize"
      [pageSizes]="[20, 50, 100]"
      (pageChange)="onPageChange($event)"
      (pageSizeChange)="onPageSizeChange($event)">
    </app-pagination>
  }

  <!-- Modelo 2 -->

  @if (modelo_tela_ligacoes == 1) {
    <div class="table-responsive">
      <div class="tabela_paginada">
        <table class="table table-sm">
          <thead>
            <tr>
              <th></th>
              <th class="tabela_borda"></th>
              <th class="tabela_borda"></th>
              <th class="text-center tabela_borda">Status</th>
              <th class="text-center tabela_borda">Nro Pedido</th>
              <th class="tabela_borda">Cliente</th>
              <th class="text-right tabela_borda">Total: R$</th>
              <th class="text-right tabela_borda">Volume Total: R$</th>
              <th class="text-center tabela_borda">Data do Pedido</th>
              <th class="tabela_borda">Prazo Pagto</th>
              <th class="text-center tabela_borda">Tipo</th>
              <th class="text-center tabela_borda">Nota Fiscal</th>
            </tr>
          </thead>
          <tbody>
            @for (pedido of pedidos; track pedido; let i = $index) {
              <tr>
                <td class="text-center tabela_acao">
                  <i class="fa  btn_tabela_acao" [ngClass]="i == itemExpandido ? 'fa-arrow-up' : 'fa-arrow-down'" placement="right" ngbTooltip="Expandir/Recolher" (click)="expandir(i, pedido.order_id_app, pedido.seller_id)"></i>
                </td>
                <td class="text-center tabela_acao tabela_borda">
                  <i class="fa fa-file btn_tabela_acao" placement="right" ngbTooltip="PDF" (click)="imprimir(pedido.order_id_app, pedido.seller_id)"></i>
                </td>
                <td class="text-center tabela_acao tabela_borda">
                  <i class="fa fa-info btn_tabela_acao" placement="right" ngbTooltip="Status" (click)="modalPedidoStatus(pedidoStatus, pedido.order_id_app)"></i>
                </td>
                <td class="text-center tabela_borda">
                  @if (pedido.status_pedido == 'À Integrar') {
                    <span class="badge badge-primary">{{ pedido.status_pedido }}</span>
                  }
                  @if (pedido.status_pedido == 'Aguard Aprov') {
                    <span class="badge badge-warning">{{ pedido.status_pedido }}</span>
                  }
                  @if (pedido.status_pedido == 'Aguard Financeiro') {
                    <span class="badge badge-financeiro">{{ pedido.status_pedido }}</span>
                  }
                  @if (pedido.status_pedido == 'Aguard Gerencial') {
                    <span class="badge badge-gerencial">{{ pedido.status_pedido }}</span>
                  }
                  @if (pedido.status_pedido == 'Aguard Diretor') {
                    <span class="badge badge-diretor">{{ pedido.status_pedido }}</span>
                  }
                  @if (pedido.status_pedido == 'Aguard Coordenador') {
                    <span class="badge badge-coordenador">{{ pedido.status_pedido }}</span>
                  }
                  @if (pedido.status_pedido == 'Aguard Cad') {
                    <span class="badge badge-secondary">{{ pedido.status_pedido }}</span>
                  }
                  @if (pedido.status_pedido == 'Cancelado') {
                    <span class="badge badge-distinct">{{ pedido.status_pedido }}</span>
                  }
                  @if (pedido.status_pedido == 'Erro Integ') {
                    <span class="badge badge-danger">{{ pedido.status_pedido }}</span>
                  }
                  @if (pedido.status_pedido == 'Faturado') {
                    <span class="badge badge-info">{{ pedido.status_pedido }}</span>
                  }
                  @if (pedido.status_pedido == 'Faturado Div') {
                    <span class="badge badge-other">{{ pedido.status_pedido }}</span>
                  }
                  @if (pedido.status_pedido == 'Integrado') {
                    <span class="badge badge-success">{{ pedido.status_pedido }}</span>
                  }
                  @if (pedido.status_pedido == 'Reprovado') {
                    <span class="badge badge-dark">{{ pedido.status_pedido }}</span>
                  }
                </td>
                <td class="text-center tabela_borda">{{ pedido.id_no_erp_do_cliente }}</td>
                <td class="tabela_borda">{{ pedido.name }}</td>
                <td class="text-right tabela_borda">{{ pedido.total | currency: 'BRL' }}</td>
                <td class="text-right tabela_borda">{{ pedido.total_volume | currency: 'BRL' }}</td>
                <td class="text-center tabela_borda">{{ pedido.order_created_at | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                <td class="tabela_borda">{{ pedido.prazo_pgto }}</td>
                <td class="text-center tabela_borda pedido_tipo_coluna">
                  <span class="pedido_tipo_conteudo">
                    <span>{{ pedido.cod_tipopedvenda }}</span>
                    @if (pedido.tipo === 'E' || pedido.tipo === 'S') {
                      <span class="badge pedido_tipo_tag" [class.badge-success]="pedido.tipo === 'E'" [class.badge-danger]="pedido.tipo === 'S'">{{ pedido.tipo }}</span>
                    }
                  </span>
                </td>
                <td class="text-center tabela_borda">{{ pedido.numero_nf }}</td>
              </tr>
              @if (i == itemExpandido) {
                <tr [@esvanecerDesvanecer]="'in'">
                  <td class="p-3" colspan="8">
                    <div class="tabela_sm tabela_itens_expandida">
                      <table class="table table-sm table-hover">
                        <thead>
                          <tr>
                            <th class="text-center">Código</th>
                            <th class="text-center tabela_borda">Sku</th>
                            <th class="tabela_borda">Descrição</th>
                            <th class="tabela_borda">Marca</th>
                            <th class="text-center tabela_borda">Qtde</th>
                            <th class="text-right tabela_borda">Unitário: R$</th>
                            <th class="text-right tabela_borda">Total: R$</th>
                            <th class="text-right tabela_borda">Volume: R$</th>
                          </tr>
                        </thead>
                        <tbody>
                          @for (pedidoItem of pedidosItens; track pedidoItem) {
                            <tr>
                              <td class="text-center">{{ pedidoItem.codigo }}</td>
                              <td class="text-center tabela_borda">{{ pedidoItem.referencia_cliente }}</td>
                              <td class="tabela_borda">{{ pedidoItem.produto }}</td>
                              <td class="tabela_borda">{{ pedidoItem.grupo_estoque }}</td>
                              <td class="text-center tabela_borda">{{ pedidoItem.quantity }}</td>
                              <td class="text-right tabela_borda">{{ formatarValoresQuatroCasasDecimais(pedidoItem.vr_unitario_original) }}</td>
                              <td class="text-right tabela_borda">{{ pedidoItem.vr_sub_total_acumulado | currency: 'BRL' }}</td>
                              <td class="text-right tabela_borda">{{ pedidoItem.volume | currency: 'BRL' }}</td>
                            </tr>
                          }
                        </tbody>
                        <tfoot>
                          @if (pedido.observacao_interna != null && pedido.observacao_interna.trim() != '') {
                            <tr>
                              <td class="tabela_itens_observacao" colspan="8"><b>Observação Interna:</b> {{ pedido.observacao_interna }}</td>
                            </tr>
                          }
                          @if (pedido.observacao_nf != null && pedido.observacao_nf.trim() != '') {
                            <tr>
                              <td class="tabela_itens_observacao" colspan="8"><b>Observação Nota Fiscal:</b> {{ pedido.observacao_nf }}</td>
                            </tr>
                          }
                          @if (pedidosItens.length > 0 && pedidosItens[0].localentrega != null && pedidosItens[0].localentrega.trim() != '') {
                            <tr>
                              <td class="tabela_itens_local_entrega" colspan="8">
                                <span><b>Local de Entrega:</b> {{ pedidosItens[0].localentrega }}</span>
                              </td>
                            </tr>
                          }
                        </tfoot>
                      </table>
                    </div>
                  </td>
                  @if (pedidosItens.length > 0) {
                    <td class="pt-3 pb-3" colspan="4">
                      <div class="text-center p-0">
                        <div class="tabela_itens_valor_total"><b>Valor Total: {{ pedidosItens[0].vr_total_acumulado | currency: 'BRL' }}</b></div>
                      </div>
                      <div class="text-center p-0">
                        @if (is_master || is_manager || is_diretor) {
                          <div class="tabela_itens_valor_margem"><b>Margem: {{ pedidosItens[0].mkt_pedido | currency: 'BRL' : '' }}%</b></div>
                        }
                      </div>
                      @if (configuracao != null && !configuracao.usa_integracao && (pedido.status_pedido == 'À Integrar' || pedido.status_pedido == 'Aguard Cad')) {
                        <div class="text-center pt-2">
                          <button class="btn btn-success btn_tabela" (click)="integrar(pedido.order_id_app, pedido.seller_id)">Integrar</button>
                        </div>
                      }
                      @if (podeAprovarPedido(pedido) && pedido.status_pedido != 'Aguard Financeiro') {
                        <div class="text-center pt-2">
                          <button class="btn btn-success btn_tabela" (click)="aprovar(pedido.order_id_app, pedido.seller_id)">Aprovar</button>
                          <button class="btn btn-danger btn_tabela"  (click)="modalPedidoReprovar(pedidoReprovar, pedido.order_id_app, pedido.seller_id)">Reprovar</button>
                          <button class="btn btn-warning btn_tabela" (click)="analisar(pedido.order_id_app, pedido.seller_id)">Analisar</button>
                        </div>
                      }
                      @if (pedido.status_pedido == 'Aguard Financeiro' && podeFinanceiroAprovar(pedido)) {
                        <div class="text-center pt-2">
                          <button class="btn btn-success btn_tabela" (click)="aprovarFinanceiro(pedido.order_id_app, pedido.seller_id)">Aprovar</button>
                          <button class="btn btn-danger btn_tabela" (click)="modalPedidoReprovarFinanceiro(pedidoReprovar, pedido.order_id_app, pedido.seller_id)">Reprovar</button>
                          <button class="btn btn-warning btn_tabela" (click)="analisarFinanceiro(pedido.order_id_app, pedido.seller_id)">Analisar</button>
                        </div>
                      }
                      @if (pedido.status_pedido == 'Erro Integ') {
                        <div class="text-center pt-2">
                          <button class="btn btn-success btn_tabela" (click)="reintegrar(pedido.order_id_app, pedido.seller_id)">Reintegrar</button>
                          <button class="btn btn-success btn_tabela" (click)="retornar(pedido.order_id_app, pedido.seller_id)">Retornar</button>
                        </div>
                      }
                      @if (pedido.status_pedido == 'Reprovado') {
                        <div class="text-center pt-2">
                          <button class="btn btn-success btn_tabela" (click)="retornar(pedido.order_id_app, pedido.seller_id)">Retornar</button>
                        </div>
                      }
                      <div class="text-center pt-2">
                        <button class="btn btn-secondary btn_tabela" (click)="duplicar(pedido.order_id_app, pedido.seller_id)">Duplicar</button>
                      </div>
                    </td>
                  }
                </tr>
              }
            }
          </tbody>
        </table>
      </div>
    </div>
    <!-- Paginação -->
    <app-pagination
      [page]="page"
      [totalPages]="totalPages"
      [totalItems]="total"
      [pageSize]="pageSize"
      [pageSizes]="[20, 50, 100]"
      (pageChange)="onPageChange($event)"
      (pageSizeChange)="onPageSizeChange($event)">
    </app-pagination>
  }
</div>
